import { render, staticRenderFns } from "./AmetrasDynamicContentDialog.vue?vue&type=template&id=c15f6656&"
import script from "./AmetrasDynamicContentDialog.vue?vue&type=script&lang=ts&"
export * from "./AmetrasDynamicContentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
